/**
 * Curated DACH tech-startup seed list.
 *
 * Same content as scripts-working/b2b-outreach/seed-companies-dach.csv,
 * shipped as a TS constant so the admin UI can offer a 1-click upload
 * without leaving the page.
 *
 * Sources: hand-picked B2B targets + Cevee Company Explore (is_active).
 * Regenerate via: python3 scripts-working/b2b-outreach/sync_seed_from_explorer.py
 *
 * Country codes are ISO-2.
 */
export interface SeedCompany {
  domain: string;
  name: string;
  country: string;
}

export const DACH_SEED_COMPANIES: SeedCompany[] = [
  { domain: 'fonio.ai', name: 'fonio.ai', country: 'AT' },
  { domain: 'hellobello.de', name: 'HelloBello', country: 'AT' },
  { domain: 'waterdrop.com', name: 'waterdrop®', country: 'AT' },
  { domain: 'aheadhealth.com', name: 'Ahead Health', country: 'CH' },
  { domain: 'usealbatross.ai', name: 'Albatross', country: 'CH' },
  { domain: 'rivr.ai', name: 'Amazon RIVR', country: 'CH' },
  { domain: 'anevo.ch', name: 'Anevo', country: 'CH' },
  { domain: 'anybotics.com', name: 'ANYbotics', country: 'CH' },
  { domain: 'bloom.diy', name: 'Bloom (YC X25)', country: 'CH' },
  { domain: 'cerrion.com', name: 'Cerrion (YC S22)', country: 'CH' },
  { domain: 'chipmind.ai', name: 'Chipmind', country: 'CH' },
  { domain: 'cradle.bio', name: 'Cradle', country: 'CH' },
  { domain: 'deepjudge.ai', name: 'DeepJudge', country: 'CH' },
  { domain: 'ethon.ai', name: 'EthonAI', country: 'CH' },
  { domain: 'femtog.com', name: 'femtoG', country: 'CH' },
  { domain: 'flexion.ai', name: 'Flexion Robotics', country: 'CH' },
  { domain: 'flink.so', name: 'Flink Robotics', country: 'CH' },
  { domain: 'hoshii.ai', name: 'Hoshii', country: 'CH' },
  { domain: 'invariantlabs.ai', name: 'Invariant Labs', country: 'CH' },
  { domain: 'lakera.ai', name: 'Lakera', country: 'CH' },
  { domain: 'langfuse.com', name: 'Langfuse', country: 'CH' },
  { domain: 'lightly.ai', name: 'Lightly', country: 'CH' },
  { domain: 'lyceum.technology', name: 'Lyceum', country: 'CH' },
  { domain: 'mentiora.ai', name: 'Mentiora', country: 'CH' },
  { domain: 'mimicrobotics.com', name: 'Mimic Robotics', country: 'CH' },
  { domain: 'octotronic.com', name: 'Octotronic', country: 'CH' },
  { domain: 'withporters.com', name: 'Porters', country: 'CH' },
  { domain: 'rivia.com', name: 'Rivia', country: 'CH' },
  { domain: 'synthara.ai', name: 'Synthara', country: 'CH' },
  { domain: 'typewise.app', name: 'Typewise', country: 'CH' },
  { domain: 'unique.ai', name: 'Unique AI', country: 'CH' },
  { domain: 'verity.net', name: 'Verity', country: 'CH' },
  { domain: '1komma5.com', name: '1KOMMA5°', country: 'DE' },
  { domain: '8returns.com', name: '8returns', country: 'DE' },
  { domain: 'aboutyou.com', name: 'ABOUT YOU', country: 'DE' },
  { domain: 'accessowl.com', name: 'AccessOwl (YC S22)', country: 'DE' },
  { domain: 'ada.com', name: 'Ada Health', country: 'DE' },
  { domain: 'adaptyvbio.com', name: 'Adaptyv Bio', country: 'DE' },
  { domain: 'adjust.com', name: 'Adjust', country: 'DE' },
  { domain: 'air-up.com', name: 'air up®', country: 'DE' },
  { domain: 'aleph-alpha.com', name: 'Aleph Alpha', country: 'DE' },
  { domain: 'amboss.com', name: 'AMBOSS', country: 'DE' },
  { domain: 'arctisai.com', name: 'Arctis AI', country: 'DE' },
  { domain: 'asioso.com', name: 'asioso', country: 'DE' },
  { domain: 'atmen.co', name: 'Atmen', country: 'DE' },
  { domain: 'autarc.energy', name: 'autarc (YC S24)', country: 'DE' },
  { domain: 'auto1.com', name: 'Auto1 Group', country: 'DE' },
  { domain: 'avelios.com', name: 'Avelios Medical', country: 'DE' },
  { domain: 'babbel.com', name: 'Babbel', country: 'DE' },
  { domain: 'bayshore.ai', name: 'bayshore.ai', country: 'DE' },
  { domain: 'bears-with-benefits.com', name: 'BEARS WITH BENEFITS', country: 'DE' },
  { domain: 'bling.de', name: 'Bling', country: 'DE' },
  { domain: 'blinkypinky.de', name: 'Blinky Pinky', country: 'DE' },
  { domain: 'bonify.de', name: 'Bonify', country: 'DE' },
  { domain: 'brandback.ai', name: 'Brandback', country: 'DE' },
  { domain: 'camunda.com', name: 'Camunda', country: 'DE' },
  { domain: 'ceezer.earth', name: 'CEEZER', country: 'DE' },
  { domain: 'cellx.ch', name: 'CellX Biosolutions', country: 'DE' },
  { domain: 'celonis.com', name: 'Celonis', country: 'DE' },
  { domain: 'centinelanalytica.com', name: 'Centinel Analytica', country: 'DE' },
  { domain: 'creamyfabrics.com', name: 'cfab (formerly creamy fabrics)', country: 'DE' },
  { domain: 'charlesandcharlotte.com', name: 'charles & charlotte', country: 'DE' },
  { domain: 'choco.com', name: 'Choco', country: 'DE' },
  { domain: 'coachhub.com', name: 'CoachHub', country: 'DE' },
  { domain: 'comena.ai', name: 'Comena (YC S25)', country: 'DE' },
  { domain: 'comstruct.com', name: 'comstruct', country: 'DE' },
  { domain: 'contentful.com', name: 'Contentful', country: 'DE' },
  { domain: 'cookiebros.de', name: 'Cookie Bros.', country: 'DE' },
  { domain: 'corintis.com', name: 'Corintis', country: 'DE' },
  { domain: 'cortea.ai', name: 'Cortea', country: 'DE' },
  { domain: 'dance.co', name: 'Dance', country: 'DE' },
  { domain: 'deeploi.io', name: 'deeploi', country: 'DE' },
  { domain: 'deliveryhero.com', name: 'Delivery Hero', country: 'DE' },
  { domain: 'demodesk.com', name: 'Demodesk', country: 'DE' },
  { domain: 'dermanostic.com', name: 'dermanostic', country: 'DE' },
  { domain: 'differential.bio', name: 'Differential Bio', country: 'DE' },
  { domain: 'doctolib.com', name: 'Doctolib', country: 'DE' },
  { domain: 'dr-emiskin.de', name: 'DR. EMI ARPA SKIN', country: 'DE' },
  { domain: 'dryft.ai', name: 'Dryft', country: 'DE' },
  { domain: 'ecoplanet.tech', name: 'ecoplanet', country: 'DE' },
  { domain: 'element.in', name: 'Element Insurance', country: 'DE' },
  { domain: 'emidat.com', name: 'Emidat', country: 'DE' },
  { domain: 'emnify.com', name: 'EMnify', country: 'DE' },
  { domain: 'enpal.de', name: 'Enpal', country: 'DE' },
  { domain: 'enpal.com', name: 'Enpal', country: 'DE' },
  { domain: 'fabel.care', name: 'fabel', country: 'DE' },
  { domain: 'femtasy.com', name: 'femtasy / Pink Internet', country: 'DE' },
  { domain: 'finanzcheck.de', name: 'FINANZCHECK', country: 'DE' },
  { domain: 'finn.com', name: 'FINN', country: 'DE' },
  { domain: 'gofinto.com', name: 'Finto', country: 'DE' },
  { domain: 'flank.ai', name: 'Flank', country: 'DE' },
  { domain: 'flink.com', name: 'Flink', country: 'DE' },
  { domain: 'flixbus.com', name: 'FlixBus', country: 'DE' },
  { domain: 'formelskin.de', name: 'FORMEL SKIN', country: 'DE' },
  { domain: 'forto.com', name: 'Forto', country: 'DE' },
  { domain: 'getyourguide.com', name: 'GetYourGuide', country: 'DE' },
  { domain: 'gorillas.io', name: 'Gorillas', country: 'DE' },
  { domain: 'got-bag.com', name: 'GOT BAG', country: 'DE' },
  { domain: 'grover.com', name: 'Grover', country: 'DE' },
  { domain: 'hades.com', name: 'Hades Mining', country: 'DE' },
  { domain: 'hallotheo.de', name: 'hallo theo', country: 'DE' },
  { domain: 'hansegruen.de', name: 'Hansegrün', country: 'DE' },
  { domain: 'hellofresh.com', name: 'HelloFresh', country: 'DE' },
  { domain: 'helsing.ai', name: 'Helsing', country: 'DE' },
  { domain: 'heycharge.com', name: 'HeyCharge', country: 'DE' },
  { domain: 'infarm.com', name: 'Infarm', country: 'DE' },
  { domain: 'inovex.de', name: 'inovex', country: 'DE' },
  { domain: 'integral.de', name: 'Integral', country: 'DE' },
  { domain: 'getivy.io', name: 'Ivy', country: 'DE' },
  { domain: 'joli-consulting.com', name: 'Joli Consulting', country: 'DE' },
  { domain: 'juit.com', name: 'Juit', country: 'DE' },
  { domain: 'juna.ai', name: 'juna.ai', country: 'DE' },
  { domain: 'kertos.io', name: 'Kertos', country: 'DE' },
  { domain: 'knowunity.com', name: 'Knowunity', country: 'DE' },
  { domain: 'kombo.dev', name: 'Kombo', country: 'DE' },
  { domain: 'lanch.com', name: 'Lanch', country: 'DE' },
  { domain: 'langdock.com', name: 'Langdock', country: 'DE' },
  { domain: 'levelninelabs.com', name: 'Level Nine Labs', country: 'DE' },
  { domain: 'lilium.com', name: 'Lilium', country: 'DE' },
  { domain: 'lio.ai', name: 'Lio', country: 'DE' },
  { domain: 'mambu.com', name: 'Mambu', country: 'DE' },
  { domain: 'manex.ai', name: 'Manex AI', country: 'DE' },
  { domain: 'matchasome.com', name: 'MATCHASOME', country: 'DE' },
  { domain: 'mercura.ai', name: 'Mercura (yc w25)', country: 'DE' },
  { domain: 'mister-spex.com', name: 'Mister Spex', country: 'DE' },
  { domain: 'mobimeo.com', name: 'Mobimeo', country: 'DE' },
  { domain: 'moss.com', name: 'Moss', country: 'DE' },
  { domain: 'n26.com', name: 'N26', country: 'DE' },
  { domain: 'n8n.io', name: 'n8n', country: 'DE' },
  { domain: 'aloha-nalu.de', name: 'NALU', country: 'DE' },
  { domain: 'getnelly.de', name: 'Nelly', country: 'DE' },
  { domain: 'neotaste.com', name: 'NeoTaste', country: 'DE' },
  { domain: 'neuralconcept.com', name: 'Neural Concept', country: 'DE' },
  { domain: 'nextcloud.com', name: 'Nextcloud', country: 'DE' },
  { domain: 'nilohealth.com', name: 'nilo', country: 'DE' },
  { domain: 'ninety-9.de', name: 'NINETY-9', country: 'DE' },
  { domain: 'nucao.de', name: 'nucao', country: 'DE' },
  { domain: 'no-cosmetics.de', name: 'Nø Cosmetics', country: 'DE' },
  { domain: 'oace.de', name: 'OACE', country: 'DE' },
  { domain: 'onward-recruiting.de', name: 'Onward Recruiting GmbH', country: 'DE' },
  { domain: 'pammys.com', name: 'Pammys', country: 'DE' },
  { domain: 'patterno.de', name: 'Patterno', country: 'DE' },
  { domain: 'peakon.com', name: 'Peakon', country: 'DE' },
  { domain: 'peec.ai', name: 'Peec AI', country: 'DE' },
  { domain: 'penta.fi', name: 'Penta', country: 'DE' },
  { domain: 'personio.com', name: 'Personio', country: 'DE' },
  { domain: 'platoapp.ai', name: 'Plato', country: 'DE' },
  { domain: 'popit-soda.com', name: 'Pop\'it Soda', country: 'DE' },
  { domain: 'prematchapp.de', name: 'Prematch', country: 'DE' },
  { domain: 'prepmymeal.com', name: 'prepmymeal', country: 'DE' },
  { domain: 'priorlabs.ai', name: 'Prior Labs', country: 'DE' },
  { domain: 'proximafusion.com', name: 'Proxima Fusion', country: 'DE' },
  { domain: 'qdrant.tech', name: 'Qdrant', country: 'DE' },
  { domain: 'qontext.ai', name: 'Qontext', country: 'DE' },
  { domain: 'quantica.io', name: 'Quantica', country: 'DE' },
  { domain: 'quantilope.com', name: 'Quantilope', country: 'DE' },
  { domain: 'raisin.com', name: 'Raisin', country: 'DE' },
  { domain: 'rematiq.com', name: 'REMATIQ', country: 'DE' },
  { domain: 'remberg.com', name: 'remberg', country: 'DE' },
  { domain: 'rootglobal.io', name: 'Root Global', country: 'DE' },
  { domain: 'rosental.de', name: 'Rosental Organics', country: 'DE' },
  { domain: 'saintsass.com', name: 'saint sass', country: 'DE' },
  { domain: 'scout24.com', name: 'Scout24', country: 'DE' },
  { domain: 'sdui.app', name: 'Sdui', country: 'DE' },
  { domain: 'sennder.com', name: 'sennder', country: 'DE' },
  { domain: 'sennheiser.com', name: 'Sennheiser', country: 'DE' },
  { domain: 'sitegeist-robotics.com', name: 'Sitegeist', country: 'DE' },
  { domain: 'snocks.com', name: 'SNOCKS', country: 'DE' },
  { domain: 'solarisgroup.com', name: 'Solaris', country: 'DE' },
  { domain: 'statista.com', name: 'Statista', country: 'DE' },
  { domain: 'strala.ai', name: 'Strala', country: 'DE' },
  { domain: 'superstreusel.de', name: 'Super Streusel', country: 'DE' },
  { domain: 'tabula.de', name: 'Tabula (YC S24)', country: 'DE' },
  { domain: 'tacto.ai', name: 'Tacto', country: 'DE' },
  { domain: 'tanso.de', name: 'Tanso Technologies', country: 'DE' },
  { domain: 'telli.com', name: 'telli (YC F24)', country: 'DE' },
  { domain: 'tier.app', name: 'TIER Mobility', country: 'DE' },
  { domain: 'tomorrow.one', name: 'Tomorrow', country: 'DE' },
  { domain: 'traderepublic.com', name: 'Trade Republic', country: 'DE' },
  { domain: 'trawa.de', name: 'trawa', country: 'DE' },
  { domain: 'upvest.co', name: 'Upvest', country: 'DE' },
  { domain: 'visable.com', name: 'Visable', country: 'DE' },
  { domain: 'voiio.de', name: 'voiio', country: 'DE' },
  { domain: 'volocopter.com', name: 'Volocopter', country: 'DE' },
  { domain: 'wefox.com', name: 'wefox', country: 'DE' },
  { domain: 'wholey.de', name: 'Wholey Organics', country: 'DE' },
  { domain: 'xing.com', name: 'XING', country: 'DE' },
  { domain: 'yfood.com', name: 'yfood Labs', country: 'DE' },
  { domain: 'zalando.com', name: 'Zalando', country: 'DE' },
  { domain: 'gozauber.com', name: 'Zauber', country: 'DE' },
  { domain: 'zeit-ai.com', name: 'Zeit AI (YC S24)', country: 'DE' },
  { domain: 'zenjob.com', name: 'Zenjob', country: 'DE' },
  { domain: 'pruna.ai', name: 'Pruna AI', country: 'FR' },
  { domain: 'adyen.com', name: 'Adyen', country: 'NL' },
  { domain: 'booking.com', name: 'Booking.com', country: 'NL' },
  { domain: 'dash0.com', name: 'Dash0', country: 'NL' },
  { domain: 'takeaway.com', name: 'Just Eat Takeaway', country: 'NL' },
  { domain: 'mendix.com', name: 'Mendix', country: 'NL' },
  { domain: 'getmoss.com', name: 'Moss', country: 'NL' },
  { domain: 'nomoriginals.com', name: 'Nom Originals', country: 'NL' },
  { domain: 'picnic.app', name: 'Picnic', country: 'NL' },
  { domain: 'einride.tech', name: 'Einride', country: 'SE' },
  { domain: 'klarna.com', name: 'Klarna', country: 'SE' },
  { domain: 'naturalcycles.com', name: 'Natural Cycles', country: 'SE' },
  { domain: 'spotify.com', name: 'Spotify', country: 'SE' },
  { domain: 'voi.com', name: 'Voi Technology', country: 'SE' },
  { domain: 'bfl.ai', name: 'Black Forest Labs', country: 'UK' },
  { domain: 'bunch.capital', name: 'bunch', country: 'UK' },
  { domain: 'godiligent.ai', name: 'Diligent (YC S23)', country: 'UK' },
  { domain: 'flower.ai', name: 'Flower Labs', country: 'UK' },
  { domain: 'gocardless.com', name: 'GoCardless', country: 'UK' },
  { domain: 'hopin.com', name: 'Hopin', country: 'UK' },
  { domain: 'kittl.com', name: 'Kittl', country: 'UK' },
  { domain: 'monzo.com', name: 'Monzo', country: 'UK' },
  { domain: 'revolut.com', name: 'Revolut', country: 'UK' },
  { domain: 'seamflow.com', name: 'Seamflow', country: 'UK' },
  { domain: 'sumup.com', name: 'SumUp', country: 'UK' },
  { domain: 'taktile.com', name: 'Taktile', country: 'UK' },
  { domain: 'trlyr.com', name: 'terralayr', country: 'UK' },
  { domain: 'voize.de', name: 'voize', country: 'UK' },
  { domain: 'wise.com', name: 'Wise', country: 'UK' },
  { domain: 'zavopay.com', name: 'Zavo (YC F25)', country: 'UK' },
];

/**
 * Build a CSV blob from the seed list. Lets the discovery panel reuse the
 * existing `uploadCompaniesCSV` endpoint (so each row gets name+country
 * populated, not just domain).
 */
export function buildSeedCsvFile(): File {
  const header = 'domain,name,country\n';
  const lines = DACH_SEED_COMPANIES.map(
    (c) => `${c.domain},${c.name.replace(/,/g, ' ')},${c.country}`,
  );
  const csv = header + lines.join('\n') + '\n';
  return new File([csv], 'dach-seed.csv', { type: 'text/csv' });
}
